(ns common.resource.query.cm360-settings
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [invalidate-queries prevent-client-error-retries]]
            [common.queries.http :as qhttp]
            [re-frame.core :as rf]))

(defn- ->id-description [{:keys [id name]}]
  {:id id :description name})

(defn- extract-id-description-options [^js data]
  (map ->id-description (:data (->clj data))))

(defn- extract-campaigns [^js data]
  (let [now (js/Date.)]
    (map (fn [{:keys [end-date] :as campaign}]
           (let [expired? (and end-date (> now (js/Date. end-date)))]
             (cond-> (->id-description campaign)
               expired? (assoc :disabled true :tag "Expired"))))
         (:campaigns (->clj data)))))

(defn- extract-sites [^js data]
  (map ->id-description (->clj data)))

(defn cm360-account-query [advertiser-id]
  #js {:queryKey #js ["cm360-account" advertiser-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/advertiser-cm360-social-account
                                           {:advertiser-id advertiser-id})))
       :enabled (boolean advertiser-id)
       :staleTime (* 5 60 1000)})

(defn assets-query [advertiser-id]
  #js {:queryKey #js ["cm360-assets" advertiser-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/advertiser-cm360-assets
                                           {:advertiser-id advertiser-id})))
       :enabled (boolean advertiser-id)
       :select extract-id-description-options
       :staleTime (* 5 60 1000)})

(defn cm360-profiles-query [advertiser-id cc-account-id]
  #js {:queryKey #js ["cm360-profiles" advertiser-id cc-account-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/advertiser-cm360-profiles
                                           {:advertiser-id advertiser-id
                                            :cc-account-id cc-account-id})))
       :enabled (boolean (and advertiser-id cc-account-id))
       :select extract-id-description-options
       :staleTime (* 5 60 1000)})

(defn cm360-advertisers-query [advertiser-id cc-account-id profile-id]
  #js {:queryKey #js ["cm360-advertisers" advertiser-id cc-account-id profile-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/advertiser-cm360-advertisers
                                           {:advertiser-id advertiser-id
                                            :cc-account-id cc-account-id}
                                           {:profile-id profile-id})))
       :enabled (boolean (and advertiser-id cc-account-id profile-id))
       :select extract-id-description-options
       :staleTime (* 5 60 1000)})

(defn cm360-campaigns-query [{:keys [advertiser-id adset-id]}]
  #js {:queryKey #js ["cm360-campaigns" advertiser-id adset-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/adset-cm360-campaigns
                                           {:advertiser-id advertiser-id
                                            :adset-id adset-id})))
       :enabled (boolean (and advertiser-id adset-id))
       :select extract-campaigns
       :staleTime (* 5 60 1000)})

(defn cm360-sites-query [{:keys [advertiser-id adset-id]}]
  #js {:queryKey #js ["cm360-sites" advertiser-id adset-id]
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/adset-cm360-sites
                                           {:advertiser-id advertiser-id
                                            :adset-id adset-id})))
       :enabled (boolean (and advertiser-id adset-id))
       :select extract-sites
       :staleTime (* 5 60 1000)})

(defn cm360-trackers-query
  [{:keys [advertiser-id adset-id decision-tree-id]}]
  #js {:queryKey #js ["cm360-trackers" advertiser-id adset-id decision-tree-id]
       :enabled (and (some? advertiser-id) (some? adset-id) (some? decision-tree-id))
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render
                              :api/content-build-adset-decision-tree-cm360-trackers
                              {:advertiser-id advertiser-id
                               :adset-id adset-id
                               :decision-tree-id decision-tree-id})))
       :staleTime (* 60 1000)})

(defn save-cm360-tracker-data-mutation
  [{:keys [advertiser-id adset-id decision-tree-id]}]
  #js {:mutationKey #js ["save-cm360-tracker-data" advertiser-id adset-id decision-tree-id]
       :mutationFn (fn [cm360-node-tracker-data]
                     (qhttp/post (qhttp/render
                                  :api/content-build-adset-decision-tree-cm360-trackers
                                  {:advertiser-id advertiser-id
                                   :adset-id adset-id
                                   :decision-tree-id decision-tree-id})
                                 {:body {:cm360-node-tracker-data cm360-node-tracker-data}}))
       :onSuccess (fn []
                    (invalidate-queries
                     {:queryKey ["cm360-trackers" advertiser-id adset-id decision-tree-id]}))})

(defn cm360-settings-query [{:keys [advertiser-id adset-id]}]
  #js {:queryKey #js ["cm360-integration-settings" advertiser-id adset-id]
       :enabled (and (some? advertiser-id) (some? adset-id))
       :queryFn (fn [_]
                  (qhttp/get (qhttp/render :api/advertiser-adset-integration-settings
                                           {:advertiser-id advertiser-id
                                            :adset-id adset-id
                                            :integration-type "cm360"})))
       :retry prevent-client-error-retries
       :staleTime (* 60 1000)})

(defn cm360-settings-mutation [{:keys [advertiser-id adset-id]}]
  #js {:mutationKey #js ["save-cm360-integration-settings" advertiser-id adset-id]
       :mutationFn (fn [body]
                     (qhttp/put (qhttp/render :api/advertiser-adset-integration-settings
                                              {:advertiser-id advertiser-id
                                               :adset-id adset-id
                                               :integration-type "cm360"})
                                {:body body}))
       :onSuccess (fn []
                    (invalidate-queries
                     {:queryKey ["cm360-integration-settings" advertiser-id adset-id]}))})

(defn upsert-cm360-account-mutation [advertiser-id]
  #js {:mutationKey #js ["upsert-cm360-account" advertiser-id]
       :mutationFn (fn [body]
                     (qhttp/put (qhttp/render :api/advertiser-cm360-social-account
                                              {:advertiser-id advertiser-id})
                                {:body (assoc body :description "CM360 configuration")}))
       :onMutate #(rf/dispatch [:loader/open])
       :onSettled #(rf/dispatch [:loader/close])
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["cm360-account" advertiser-id]})
                    (rf/dispatch [:ocp/close])
                    (rf/dispatch [:response-handler/handle-response
                                  {:type :success
                                   :message "CM360 configuration saved"}]))
       :onError (fn [_]
                  (rf/dispatch [:response-handler/handle-response
                                {:type :error
                                 :message "Failed to save CM360 configuration"}]))})

(defn delete-cm360-account-mutation [advertiser-id]
  #js {:mutationKey #js ["delete-cm360-account" advertiser-id]
       :mutationFn (fn [_]
                     (qhttp/delete (qhttp/render :api/advertiser-cm360-social-account
                                                 {:advertiser-id advertiser-id})))
       :onMutate #(rf/dispatch [:loader/open])
       :onSettled #(rf/dispatch [:loader/close])
       :onSuccess (fn []
                    (invalidate-queries {:queryKey ["cm360-account" advertiser-id]})
                    (rf/dispatch [:response-handler/handle-response
                                  {:type :success
                                   :message "CM360 configuration deleted"}]))
       :onError (fn [_]
                  (rf/dispatch [:response-handler/handle-response
                                {:type :error
                                 :message "Failed to delete CM360 configuration"}]))})
